module.exports = __webpack_public_path__ + "img/star-yellow.faa4439c.svg";